// Dependencies
require("webstrap/type");

// Styles
require("./liste.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/element/liste/index.js
 ** module id = 158
 ** module chunks = 0 1
 **/